import { useState } from "react";
import { ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import { Container, Row, Col, Button } from "react-bootstrap";
function VoteFields({
    choices,
    participation,
    changerPage
}) {
    const [value, setValue] = useState('')
    const [disabled, setDisabled] = useState(true)

    const handleChangeVote = async (val) => {
        participation.voteValue = { 'choice_ids': [val] };
        setValue(val)
        setDisabled(false);
    }

    return (
        <Container className="custom-vote">
            <Row className="text-center">
                <Col>
                    <ToggleButtonGroup type="radio" name="choices" vertical="true" className="btn-custom-vote" defaultValue={[]} onChange={handleChangeVote} value={value}>
                        {choices.map((choice) => (
                            <ToggleButton id={choice.id} value={choice.id} key={`key-choice-${choice.id}`} className="d-flex align-items-center justify-content-center">
                                {choice.label}
                            </ToggleButton>
                        ))}
                    </ToggleButtonGroup>
                </Col>
            </Row>
            <Row className="custom-commandes">
                <Col>
                    <Button onClick={changerPage} disabled={disabled}>Continuer</Button>
                </Col>
            </Row>
        </Container>
    );
}
export default VoteFields;